import HTTP from "../../HTTP";
import Jsona from "jsona";

import helpers from "../../helpers/coupons";

const dataFormatter = new Jsona();

export default {
  async index(accountId, number_page = 0) {
    try {
      const page = `page[number]=${number_page}`;
      const includes = `include=orders`;

      const results = await HTTP.normal.get(
        `/accounts/${accountId}/coupons?${page}&${includes}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (_) {
      throw "Ocorreu um erro ao listar os cupons do profissional!";
    }
  },

  async create(accountId, coupon) {
    const data = {
      type: "coupons",
      attributes: {
        max_usage: { total: parseInt(coupon.max_usage.total) }
      },
      relationships: {
        accounts: {
          data: { type: "account", id: accountId }
        }
      }
    };

    try {
      return await HTTP.normal.post("/professional_coupons", {
        data: data
      });
    } catch (e) {
      throw e.response.data.errors.map(err => err.detail);
    }
  },

  async getById(id) {
    try {
      const result = await HTTP.normal.get(`/coupons/${id}`);
      return dataFormatter.deserialize(result.data);
    } catch (_) {
      throw "Ocorreu um erro ao buscar o cupom!!";
    }
  },

  async update(coupon) {
    const data = helpers.updateProfessionalCouponBody(coupon);
    try {
      return await HTTP.normal.patch(`/coupons/${coupon.id}`, data);
    } catch (e) {
      throw e.response.data.errors.map(err => err.detail);
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/professionals/coupons.js